import React, { useEffect, useState } from 'react';
import { Box, Paper, Typography, Grid, Card, CardContent } from '@mui/material';
import api from '../services/api';

const StatCard: React.FC<{ title: string; value: number }> = ({ title, value }) => (
    <Card>
        <CardContent>
            <Typography variant="subtitle2">{title}</Typography>
            <Typography variant="h5">{value}</Typography>
        </CardContent>
    </Card>
);

const SignaturesDashboard: React.FC = () => {
    const [counts, setCounts] = useState<{ [k: string]: number }>({});

    useEffect(() => {
        (async () => {
            try {
                const res = await api.get('/api/signatures');
                const items = res.data || [];
                const summary: any = { total: items.length };
                items.forEach((it: any) => {
                    const s = it.status || 'unknown';
                    summary[s] = (summary[s] || 0) + 1;
                });
                setCounts(summary);
            } catch (err) {
                console.error(err);
            }
        })();
    }, []);

    return (
        <Box sx={{ p: 2 }}>
            <Paper sx={{ p: 2 }}>
                <Typography variant="h6">Dashboard de Assinaturas</Typography>
                <Box sx={{ mt: 1, display: 'grid', gap: 2, gridTemplateColumns: { xs: '1fr', sm: 'repeat(2, 1fr)', md: 'repeat(4, 1fr)' } }}>
                    <Box>
                        <StatCard title="Total" value={counts.total || 0} />
                    </Box>
                    <Box>
                        <StatCard title="Pendentes" value={counts.pending || 0} />
                    </Box>
                    <Box>
                        <StatCard title="Enviadas" value={counts.sent || 0} />
                    </Box>
                    <Box>
                        <StatCard title="Finalizadas" value={counts.signed || 0} />
                    </Box>
                </Box>
            </Paper>
        </Box>
    );
};

export default SignaturesDashboard;
